import React from "react";
import { TextField } from "@mui/material";
import { VM_Colors } from "../Styles/VMStyles";

function MUITextField(props) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      InputProps={{
        style: {
          fontFamily: "Lato",
          fontSize: "16px",
        },
      }}
      // sx={{
      //   backgroundColor: "#fff",
      //   "& .MuiOutlinedInput-root": {
      //     borderRadius: "6px",
      //     "& fieldset": {
      //       borderColor: "#C3C3C3",
      //     },
      //     "&:hover fieldset": {
      //       borderColor: "#999",
      //     },
      //     "&.Mui-focused fieldset": {
      //       borderColor: "#1E3A8A",
      //     },
      //   },
      //   input: {
      //     fontFamily: "Lato",
      //     fontSize: { xs: "14px", sm: "15px", md: "16px" },
      //   },
      //   ...placeholderStyle
      // }}

              sx={{
                backgroundColor: VM_Colors.white,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                  // fontFamily: "Lato", 
                fontWeight:400,
                fontStyle:"normal",
                fontSize: "16px",   
                opacity: 1, // Ensure visibility, as some browsers use lower opacity by default
              
                  backgroundColor: VM_Colors.white,
                  "& fieldset": {
                    borderColor: "#C3C3C3",
                  },
                  "&:hover fieldset": {
                    borderColor: "#A0A0A0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1E3A8A",
                  },
                },
      
                // "& input[type=number]": {
                //   MozAppearance: "textfield", // Firefox
                //   "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                //     WebkitAppearance: "none",
                //     margin: 0,
                //   },
                // },
      
                // "& input": {
                //   fontSize: "16px",
                // },
                '& .MuiInputBase-input::placeholder': {
                // fontFamily: "Lato",
                fontWeight:400,
                fontStyle:"normal",
                fontSize: "16px",   
                color:VM_Colors.steel_gray,
                opacity: 1, // Ensure visibility, as some browsers use lower opacity by default
                // Add any other styles (e.g., color, fontWeight) here
              }
              }}
      {...props}
    />
  );
}

export default MUITextField;
